import React, { useEffect } from 'react'
import { makeStyles, createStyles, BottomNavigation, BottomNavigationAction } from '@material-ui/core'
import { ReactComponent as CalendarFillIconReverse } from '../assets/icons/medical_services_reverse.svg'
import { ReactComponent as PromotionReverse } from '../assets/icons/auto_awesome_reverse.svg'
import { ReactComponent as HomeReverse } from '../assets/icons/homeBar_reverse.svg'
import { ReactComponent as MineReverse } from '../assets/icons/mine_reverse.svg'

import { ReactComponent as CalendarFillIcon } from '../assets/icons/medical_services.svg'
import { ReactComponent as Promotion } from '../assets/icons/auto_awesome.svg'
import { ReactComponent as Home } from '../assets/icons/homeBar.svg'
import { ReactComponent as Mine } from '../assets/icons/mine.svg'

import { useHistory, useRouteMatch } from 'react-router-dom'
import { matchPath, useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'sticky',
      height: theme.spacing(8.25),
      bottom: 0,
      zIndex: theme.zIndex.appBar,
      borderTop: '1px solid #E5E7EB',
    },
    actionRoot: {
      color: theme.palette.primary.light,
      margin: 0,
      // '& path': {
      //    fill: theme.palette.primary.light,
      // },
    },
    actionActive: {
      // color: theme.palette.secondary.main,
      '& path': {
        fill: theme.palette.secondary.main,
      },
      '&$label': {
        fontSize: 12,
        color: 'black',
      },
      '.MuiBottomNavigationAction-iconOnly': {
        backgroundColor: '#FEEEEA',
        color: 'red',
        borderRadius: 18,
      },
    },
    label: {
      fontSize: 12,
      marginTop: '2px',
    },
    label2: {
      fontSize: 12,
      marginTop: '2px',
      color: 'black',
    },
    icon: {
      width: 56,
      height: 30,
      paddingTop: 3,
      paddingBottom: 3,
      // marginTop: 8,
      color: '#4B5563',
    },
    icon1: {
      width: 56,
      height: 30,
      paddingTop: 3,
      paddingBottom: 3,
      // marginTop: 8,
      backgroundColor: '#FEEEEA',
      color: 'red',
      borderRadius: 18,
    },
  }),
)

const BottomNavbar = () => {
  const classes = useStyles()
  const history = useHistory()
  const { t, i18n } = useTranslation()
  const { pathname } = useLocation()
  const [value, setValue] = React.useState(0)
  const navConfig = [
    { label: t('glossary.homepage'), path: `/${i18n.language}`, icon: Home, iconReverse: HomeReverse },
    {
      label: t('glossary.product_list'),
      path: `/${i18n.language}/ProductList`,
      icon: CalendarFillIcon,
      iconReverse: CalendarFillIconReverse,
    },
    {
      label: t('common.promotion_menu'),
      path: `/${i18n.language}/promotion`,
      icon: Promotion,
      iconReverse: PromotionReverse,
    },
    {
      label: t('common.my_account'),
      path: `/${i18n.language}/profile/account`,
      icon: Mine,
      iconReverse: MineReverse,
    },
  ]
  const hideBottomBar =
    useRouteMatch(`/${i18n.language}/add-order`) ||
    useRouteMatch(`/${i18n.language}/clinic`) ||
    useRouteMatch(`/${i18n.language}/preOrder`) ||
    useRouteMatch(`/${i18n.language}/profile/order`) ||
    useRouteMatch(`/${i18n.language}/product-prophecy`) ||
    useRouteMatch(`/${i18n.language}/product-cancer-screening`) ||
    useRouteMatch(`/${i18n.language}/product-male-health-check-package`) ||
    useRouteMatch(`/${i18n.language}/product-female-health-check-package`) ||
    useRouteMatch(`/${i18n.language}/product-standard-health-check-package`)

  useEffect(() => {
    const showNav = navConfig.findIndex((item) => matchPath(pathname, { path: item.path, exact: true }))
    setValue(showNav)
  }, [pathname])

  const handleChange = (event, newValue) => {
    setValue(newValue)
    history.push(navConfig[newValue]?.path)
  }

  const IconRender = (nav, index) => {
    if (useRouteMatch(`/${i18n.language}/profile/order`) && index === 3) {
      return <MineReverse className={classes.icon1} />
    }
    if (useRouteMatch(`/${i18n.language}/promotions_NEW330`) && index === 2) {
      return <PromotionReverse className={classes.icon1} />
    }
    if (index !== value) {
      return <nav.icon className={classes.icon} />
    }

    return <nav.iconReverse className={classes.icon1} />
  }

  return hideBottomBar ? null : (
    <BottomNavigation value={value} onChange={handleChange} showLabels className={classes.root}>
      {navConfig?.map((nav, index) => (
        <BottomNavigationAction
          classes={{
            root: classes.actionRoot,
            selected: classes.actionActive,
            label:
              (useRouteMatch(`/${i18n.language}/profile/order`) && index === 3) ||
              (useRouteMatch(`/${i18n.language}/promotions_NEW330`) && index === 2)
                ? classes.label2
                : classes.label,
          }}
          label={t(nav.label)}
          icon={IconRender(nav, index)}
          key={nav.label}
        />
      ))}
    </BottomNavigation>
  )
}

export default BottomNavbar
